import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Store } from '@sama/app-state';

export function reorderInStore<T extends Store<any[]>>(
  arrayStore: T,
  event: { previousIndex: number; currentIndex: number },
) {
  const listLength = arrayStore.state().length;
  const previousPosition = listLength - 1 - event.previousIndex;
  const newPosition = listLength - 1 - event.currentIndex;
  arrayStore.mutateUsing(moveItemInArray, previousPosition, newPosition);
  return { previousPosition, newPosition };
}
